import React, { useEffect } from 'react'
import styled from 'styled-components'
import ErrorOutline from '@mui/icons-material/ErrorOutline'

import ModalButton from 'components/Modal/Button'
import Modal from 'components/Modal'

import Apptentive from 'helpers/apptentive'
import { ButtonContainer } from 'styles/shared'
import Brand from 'helpers/brand'
import GA4 from 'helpers/ga4'

import { useNavigate } from 'react-router-dom'
import usePaywallActiveAcct from 'hooks/usePaywallActiveAcct'
import Spinner from 'components/Spinner'

type Props = {
  closeCallback: (reloadPage) => void
  dealerId: number
  error: string
}

const PaywallFailureModal = ({ dealerId, closeCallback, error } : Props) => {
  const navigate = useNavigate()
  const { account, isPaywallAcctLoaded } = usePaywallActiveAcct(dealerId)

  const onClickClose = () => {
    closeCallback(false)
  }

  const onClickTryAgain = () => {
    if (account) {
      navigate(`/paywall/details/${dealerId}`)
    } else {
      navigate(`/paywall/options/${dealerId}`)
    }
    closeCallback(true)
  }

  useEffect(() => {
    Apptentive.sendEvent('premium_acct_failed')

    GA4.sendEvent({
      action: 'Premium Account Failed',
      category: 'Premium Settings',
      label: `Failure Reason: ${error}`
    })
  }, [error])

  if (!isPaywallAcctLoaded) {
    return <Spinner variant="page" />
  }

  return (
    <Modal variant="sm" isDisplayed closeCallback={() => closeCallback(false)}>
      <S.Top>
        <S.ProductLogo src={Brand.premiumProductLogoPath()} alt={`${Brand.brandName()} logo`} />
        <div />
      </S.Top>
      <S.FailureBox>
        <S.ErrorOutline fontSize="large" />
        <S.FailureText>Error</S.FailureText>
      </S.FailureBox>
      <p>There was an issue with your payment.</p>
      <p>Please try again or call Support <u>844-359-0270</u> for assistance.</p>

      <ButtonContainer noBorder>
        <ModalButton decoration="secondary" text="Cancel" styles={{ button: { marginLeft: 15 } }} onPress={onClickClose} />
        <ModalButton decoration="positive" text="Try Again" styles={{ button: { marginLeft: 15 } }} onPress={onClickTryAgain} />
      </ButtonContainer>
    </Modal>
  )
}

export default PaywallFailureModal

const S = {
  ErrorOutline: styled(ErrorOutline)`
    color: #2C7AC2;
    padding-right: 3px;
  `,
  Explanation: styled.li`
    margin: 10px 0 0 0;
    padding-right: 5px;
    padding-left: 5px;
  `,
  ProductLogo: styled.img`
    height: 50px;
  `,
  FailureBox: styled.div`
    display: flex;
    align-items: center;
  `,
  FailureText: styled.div`
    font-size: 18px;
    font-weight: bold;
    color: #2C7AC2;
    text-transform: none;
  `,
  Top: styled.div`
    display: flex;
    justify-content: center;
    padding: 10px;
  `
}
